import { render, staticRenderFns } from "./ChannelSelectionDialog.vue?vue&type=template&id=e6799250&scoped=true"
import script from "./ChannelSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ChannelSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelectionDialog.vue?vue&type=style&index=0&id=e6799250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6799250",
  null
  
)

export default component.exports